<template>
  <div class="checkoutFinishError">
    <StepView :active-index="2" :steps="steps"></StepView>
    <finish-page button-caption="К заказам" :exit-route="{name: 'OrdersView'}" style="background-color: darkred;color: white">
      <template #mainText>
        <span class="checkoutFinishError__head">
          Заказ {{ $route.query.order_id }} создан, но не оплачен!
        </span>
      </template>
      <template #infoText>
        <span class="checkoutFinishError__info">
        Вы можете  посмотреть детали заказа, и оплатить, а также отслеживать доставку в личном кабинете.
        </span>
      </template>

    </finish-page>
  </div>
</template>

<script>
import FinishPage from "@/components/shared/FinishPage.vue";
import StepView from "@/components/CartView/StepView.vue";
import {useCartTools} from "@/composables/cart-tools";

export default {
  name: "CheckoutFinisErrorhView" ,
  components: {StepView, FinishPage},
  setup() {
    const cartTools = useCartTools();
    return {
      steps: cartTools.cartSteps
    }
  }
}
</script>


<style scoped lang="scss">
.checkoutFinishError {
  &__head {
    font-weight: 500;
    font-size: 36px;
    font-family: var(--cd-bold-font);
  }
  &__info {
  }
}
</style>
